import React, { Fragment } from "react";

const MissionVision = () => {
  return (
    <Fragment>
      <section className="bg-gray-50 bg-opacity-85 ">
        <div className="container px-8 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20">
          <div className="max-w-xl mb-10 md:mx-auto sm:text-center lg:max-w-2xl md:mb-12">
            <h2 className="max-w-2xl mb-6 font-sans text-3xl font-bold leading-none tracking-normal text-green-900 sm:text-5xl md:mx-auto custom-font-2">
              <span className="relative inline-block">
                <svg
                  viewBox="0 0 52 24"
                  fill="currentColor"
                  className="absolute top-0 left-0 z-0 hidden w-32 -mt-8 -ml-20 text-amber-400 lg:w-32 lg:-ml-28 lg:-mt-10 sm:block"
                >
                  <defs>
                    <pattern
                      id="bebc38d1-bf72-4c77-a073-f0fe5abe0753"
                      x="0"
                      y="0"
                      width=".135"
                      height=".30"
                    >
                      <circle cx="1" cy="1" r=".7"></circle>
                    </pattern>
                  </defs>
                  <rect
                    fill="url(#bebc38d1-bf72-4c77-a073-f0fe5abe0753)"
                    width="52"
                    height="24"
                  ></rect>
                </svg>
                <span className="relative">
                  Our Commitment: <br />
                  Mission & Vision
                </span>
              </span>
            </h2>
            <p className="text-gray-700 text-xl custom-font-2 tracking-wide font-medium">
              Empowering change through solar innovation, <br />
              our commitment shines a light on a greener future.
            </p>
          </div>
          {/* <!--  --> */}
          <div className="flex flex-wrap -m-4">
            <div className="p-4 md:w-1/2 w-full">
              <div className="h-full bg-gray-100 p-8 rounded-xl shadow-xl transition-shadow">
                <a className="inline-flex items-center" href="/">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="rgb(20 83 45)"
                    className="block w-5 h-5 text-gray-400 mb-4"
                    viewBox="0 0 975.036 975.036"
                  >
                    <path d="M925.036 57.197h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.399 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l36 76c11.6 24.399 40.3 35.1 65.1 24.399 66.2-28.6 122.101-64.8 167.7-108.8 55.601-53.7 93.7-114.3 114.3-181.9 20.601-67.6 30.9-159.8 30.9-276.8v-239c0-27.599-22.401-50-50-50zM106.036 913.497c65.4-28.5 121-64.699 166.9-108.6 56.1-53.7 94.4-114.1 115-181.2 20.6-67.1 30.899-159.6 30.899-277.5v-239c0-27.6-22.399-50-50-50h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.4 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l35.9 75.8c11.601 24.399 40.501 35.2 65.301 24.399z"></path>
                  </svg>
                  <span className="flex-grow flex flex-col pl-4 mb-4">
                    <span className="title-font text-2xl font-semibold text-gray-900 custom-font-2 tracking-normal">
                      OUR MISSION
                    </span>
                  </span>
                </a>

                <p className="leading-relaxed mb-6 tracking-wide text-lg font-medium text-gray-700 custom-font-2">
                  To provide reliable, high-quality solar installation services
                  and retail products, empowering individuals and communities to
                  make environmentally responsible choices while reducing their
                  energy costs. We strive to meet the unique needs of our
                  clients by offering customized solutions that exceed their
                  expectations and maximize their savings potential. Through our
                  commitment to sustainability and customer satisfaction, we aim
                  to inspire and promote a cleaner, more sustainable future for
                  generations to come.
                </p>
              </div>
            </div>
            <div className="p-4 md:w-1/2 w-full">
              <div className="h-full bg-gray-100 p-8 rounded-xl shadow-xl transition-shadow">
                <a className="inline-flex items-center" href="/">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="rgb(20 83 45)"
                    className="block w-5 h-5 text-gray-400 mb-4"
                    viewBox="0 0 975.036 975.036"
                  >
                    <path d="M925.036 57.197h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.399 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l36 76c11.6 24.399 40.3 35.1 65.1 24.399 66.2-28.6 122.101-64.8 167.7-108.8 55.601-53.7 93.7-114.3 114.3-181.9 20.601-67.6 30.9-159.8 30.9-276.8v-239c0-27.599-22.401-50-50-50zM106.036 913.497c65.4-28.5 121-64.699 166.9-108.6 56.1-53.7 94.4-114.1 115-181.2 20.6-67.1 30.899-159.6 30.899-277.5v-239c0-27.6-22.399-50-50-50h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.4 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l35.9 75.8c11.601 24.399 40.501 35.2 65.301 24.399z"></path>
                  </svg>
                  <span className="flex-grow flex flex-col pl-4 mb-4">
                    <span className="title-font text-2xl font-semibold text-gray-900 custom-font-2 tracking-normal">
                      OUR VISION
                    </span>
                  </span>
                </a>

                <p className="leading-relaxed mb-6 tracking-wide text-lg font-medium text-gray-700 custom-font-2">
                  Committed to transforming the world's energy landscape through
                  innovative solar technologies and sustainable solutions. Our
                  vision is to harness the power of the sun to create clean,
                  affordable, and reliable energy for all, while reducing our
                  carbon footprint and promoting a more sustainable future for
                  generations to come. We aim to be a leading provider of solar
                  energy solutions, recognized for our technical expertise,
                  exceptional customer service, and commitment to driving
                  positive change in the world.
                </p>
              </div>
            </div>
          </div>
          {/* <!--  --> */}
        </div>
      </section>
    </Fragment>
  );
};

export default MissionVision;
